module.exports = __webpack_public_path__ + "img/badge_bonusx.e40a9ebc.jpg";